export default __webpack_public_path__ + "static/media/section2-bg2.cd6366d3.png";